export function matches(fieldNameToMatch, valueToMatch = '') {
  return fieldName => (value = '') =>
    value === valueToMatch
      ? undefined
      : `${fieldName} and ${fieldNameToMatch} values don't match`;
}
